import React from "react";
import { motion } from "framer-motion";
import { pageVariants } from "../animations/pageTransitions"; // Import animation config
import "./Capabilities.css";
import dermatology from "../../practices_images/dermatology.jpg"; // Ensure this path is correct
import CollapsibleSection from "./CollapsibleSection"; // adjust path if needed

const Dermatology = () => {
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div className="cap-container">
        <h1>Dermatology</h1>

        <div className="cap-section">
          <div className="text-content">
            {/* ✅ First 2 sections: normal (always visible) */}
            <h3>Supporting high volume care with operational discipline</h3>
            <p>
              Dermatology practices operate at the intersection of clinical care, procedures, and patient experience. Many manage a mix of medical and procedural services while maintaining high visit volumes and tight scheduling requirements.   
            </p>
            <p>
              We work with dermatology practices to help them operate efficiently while maintaining consistency, accuracy, and financial control.
            </p>
  
            <h3>The Operating Environment</h3>
            <p>
              Dermatology clinics require streamlined workflows to support frequent patient visits, procedural documentation, and reliable reimbursement. Practices must manage variations in payer rules, procedure based coding, and documentation standards while maintaining a smooth patient experience.
            <p>
            </p>
              Without aligned systems, operational friction can limit both clinical throughput and financial performance.
            </p>
  
            {/* ✅ Everything after: collapsible */}
            <CollapsibleSection title="Our Role">
              <p>
                We help dermatology practices strengthen the operational and financial foundations that support sustainable growth.
              </p>
              <p>
                Our work focuses on improving scheduling efficiency, reinforcing documentation and coding accuracy for medical and procedural services, supporting reliable billing and revenue cycle processes, and improving financial visibility across the practice.
              </p>
              <p>
                Our approach reflects the pace and complexity of modern dermatology care.
              </p>
            </CollapsibleSection>
  
            <CollapsibleSection title="Enabling Consistency and Growth">
              <p>
                Our goal is to help practices operate with clarity and control in a high volume environment.
              </p>
              <p>
                By reducing administrative friction and improving financial insight, we support better use of staff time, more predictable revenue, and a consistent experience for patients across visits and services.
              </p>
              <p>
                This allows clinicians to remain focused on care while leadership maintains operational oversight.
              </p>
            </CollapsibleSection>
  
            <CollapsibleSection title="Looking Ahead">
              <p>
                As dermatology practices continue to evolve and expand their service mix, strong operational fundamentals remain essential.
              </p>
              <p>
                We partner with practices to build the structure and discipline required to support long term success.
              </p>
              <p>
                Let’s begin a conversation about how your practice can move forward with confidence and purpose.
              </p>
            </CollapsibleSection>
          </div>

          {/* Image Section */}
          <div className="image-container">
            <img src={dermatology} alt="Dermatology" />
          </div>

        </div>
      </div>
    </motion.div>
  );
};

export default Dermatology;
